import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import masterField from '../../../../components/search-form/master-field';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';

class IncludeOppenOpportunities extends Component {

  render() {
    const { includeOpenOpportunities, canManage } = this.props;

    let label = null;
    if (includeOpenOpportunities) {
      label = 'Open and closed opportunities will be displayed.';
    } else {
      label = 'Only closed opportunities will be displayed.';
    }

    let anchor = null;
    if (canManage) {
      anchor = (
        <span><Link to="/setup/feedback-module">Edit</Link></span>
      );
    }

    return (
      <div style={{ paddingTop: '4px' }}>
        {label} {anchor}
      </div>
    );
  }
}
function mapStateToProps(state) {
  const canManage = getCanSetupOrganization(state);
  return {
    canManage,
  };
}

IncludeOppenOpportunities.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchCriteria: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  }),
  onUpdate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  includeOpenOpportunities: PropTypes.bool,
  canManage: PropTypes.bool,
};
IncludeOppenOpportunities.defaultProps = {
  searchCriteria: null,
  disabled: false,
  readOnly: false,
  includeOpenOpportunities: false,
  canManage: false,
};


export default masterField(connect(mapStateToProps)(IncludeOppenOpportunities));
